module.exports = __webpack_public_path__ + "static/nantescraft-8747e738d5975a77e66c1f6c77484c87.png";